import React, { useEffect, useState } from 'react'
import { Box, FormControlLabel, Grid, IconButton, Radio, RadioGroup } from '@material-ui/core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


export default function GradiantBackground({gradient,setGradient}) {
    const [color1, setColor1] = useState('#1488cc')
    const [color2, setColor2] = useState('#2b32b2')
    const [direction, setDirection] = useState('to bottom')
    const [type, setType] = useState('linear-gradient')

    useEffect(()=>{
        setGradient(`${type}(${direction}, ${color1}, ${color2})`)
    },[color1,color2,direction,type])
  return (
    <Box
      sx={{ height: '400px' }}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box
                    sx={{
                        width: "100%",
                        height: '200px',
                        borderRadius: '10px',
                        backgroundImage:gradient
                    }}
                />
            </Grid>
            <Grid item xs={6} style={{display:'flex'}} justifyContent='center'>
                <input
                    type="color"
                    className="form-control col-6"
                    value={color1}
                    onChange={(e) => {
                        setColor1(e.target.value)
                    }}
                />
            </Grid>
            <Grid item xs={6} style={{display:'flex'}} justifyContent='center'>
                <input
                    type="color"
                    className="form-control col-6"
                    value={color2}
                    onChange={(e) => {
                        setColor2(e.target.value)
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <Box className="d-flex align-items-center justify-content-around">
                <IconButton
                    color={direction=="to top" ? "primary" :""}
                    onClick={(event) => setDirection('to top')}
                    style={{ border: '1px solid', transform: 'rotate(-90deg)' }}
                >
                   <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to bottom" ? "primary" :""}
                    onClick={(event) => setDirection('to bottom')}
                    style={{ border: '1px solid', transform: 'rotate(90deg)' }}
                >
                   <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to right" ? "primary" :""}
                    style={{ border: '1px solid'}}
                    onClick={(event) => setDirection('to right')}
                >
                    <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to left" ? "primary" :""}
                    onClick={(event) => setDirection('to left')}
                    style={{ border: '1px solid', transform: 'rotate(180deg)' }}
                >
                    <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to top right" ? "primary" :""}
                    onClick={(event) => setDirection('to top right')}
                    style={{ border: '1px solid', transform: 'rotate(-45deg)' }}
                >
                    <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to bottom left" ? "primary" :""}
                    onClick={(event) => setDirection('to bottom left')}
                    style={{ border: '1px solid', transform: 'rotate(-225deg)' }}
                >
                    <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to bottom right" ? "primary" :""}
                    onClick={(event) => setDirection('to bottom right')}
                    style={{ border: '1px solid', transform: 'rotate(45deg)' }}
                >
                   <ArrowForwardIcon/>
                </IconButton>
                <IconButton
                    color={direction=="to top left" ? "primary" :""}
                    onClick={(event) => setDirection('to top left')}
                    style={{ border: '1px solid', transform: 'rotate(225deg)' }}
                >
                    <ArrowForwardIcon/>
                </IconButton>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <RadioGroup
                    row
                    value={type}
                    onChange={(e)=>{
                        setType(e.target.value)
                        if(e.target.value == 'radial-gradient'){
                            setDirection('circle')
                        }
                    }}
                    style={{justifyContent : "center"}}
                >
                    <FormControlLabel labelPlacement="bottom" value="linear-gradient" control={<Radio />} label="Linear" />
                    <FormControlLabel labelPlacement="bottom" value="radial-gradient" control={<Radio />} label="Radial" />
                </RadioGroup>
            </Grid>
        </Grid>
    </Box>
  )
}
